import * as React from 'react'
import injectSheet from 'react-jss'
import {layers} from '../Style'

const styles = {
    root: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: layers.front,
    }
}

interface Props {

}

export const TableCellGrayOutOverlay =
    injectSheet<Props>(styles)(
        ({classes}) => (
            <div className={classes.root}/>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/TableCellGrayOutOverlay.tsx